import { defineStore } from 'pinia'
import { ApiRequest } from '@/requests/ApiRequest'
import type { Token } from '@/typings/Users/Token'
import type { UsersMe } from '@/typings/Users/UsersMe'
import type { User } from '@/typings/Users/User'

export const useAuthStore = defineStore('auth', {
  getters: {
    api: () => new ApiRequest(),
    isAuthorized: () => !!localStorage.getItem('authUser'),
  },
  actions: {
    async me() {
      const response = await this.api.get<UsersMe>('/users/me')
      localStorage.setItem('authUser', JSON.stringify(response))
      return response
    },

    async logIn(email: string, password: string) {
      const response = await this.api.post<Token>('/auth/login', { email, password })
      if (response.message) {
        return false
      }

      localStorage.setItem('authToken', response.access_token || '')
      localStorage.setItem('authTokenType', response.token_type || 'Bearer')

      await this.me()
      return true
    },

    logout() {
      localStorage.removeItem('authUser')
      localStorage.removeItem('authToken')
      localStorage.removeItem('authTokenType')
    },

    getCurrentUser(): User | null {
      const userData = localStorage.getItem('authUser')
      if (!userData) {
        return null
      }
      const user = JSON.parse(userData)
      return user.data
    },
  },
})
